import { inject, Injectable } from '@angular/core';
import { UserModel } from '@libs/account/models';
import { Observable } from 'rxjs';
import { AgentRepositoryService } from './agent.repository.service';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  private readonly repo: AgentRepositoryService = inject(AgentRepositoryService);

  public search(filter: string, page: number = 1, pageSize: number = 10): Observable<UserModel[]> {
    return this.repo.search(filter, page, pageSize);
  }
}
